import axios from "../../axios"

export const getMonthlySummary = async (accountId) => {
    try {
        const resp = await axios(`/api/v3/analysis/transactionSummary?accountId=${accountId}`);
        return resp.data;
    } catch (error) {
        throw error
    }
}